import { render, staticRenderFns } from "./dxyqsb.vue?vue&type=template&id=9d83a8be&scoped=true"
import script from "./dxyqsb.vue?vue&type=script&lang=js"
export * from "./dxyqsb.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9d83a8be",
  null
  
)

export default component.exports